export default class CollaboratorPriceTable {
    constructor() {
        this.id = "";
        this.collaboratorId = "";
        this.typePrice = { content: '', id: "" };
        this.quantity = 1;
        this.value = 0;
    }
    update(data) {
        this.id = data.id;
        this.collaboratorId = data.collaboratorId;
        this.typePrice = { id: data.typePrice.id, content: data.typePrice.content };
        this.quantity = data.quantity;
        this.value = data.value;
    }
}
